<div class="app-background-image-wrapper">
  <img src="assets/product/background-web.jpg" alt="background image: monochromatic home interior" class="app-background-image">
</div>
<app-notifications [enableAnimations]="enableAnimations"></app-notifications>
<div class="position-relative">
  <router-outlet [@.disabled]="!enableAnimations"></router-outlet>
</div>
